<template>
  <tr>
    <slot>
      <td v-for="(row, index) in rows" v-bind:key="index" :class="row.style" class="align-middle">
        {{ row.value }}
      </td>
    </slot>
    <td v-if="actionItems || $slots.actionItems" class="align-middle text-end actions">
      <div class="d-flex justify-content-end mr-3">
        <slot name="actionItems">
          <ActionIcons :actions="actionItems" />
        </slot>
      </div>
    </td>
    <td v-if="menuItems || $slots.menuItems" class="text-end actions">
      <div class="d-flex justify-content-end mr-4">
        <slot name="actionItems">
          <ThreeDotsMenu :items="menuItems" />
        </slot>
      </div>
    </td>
  </tr>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "TableRow",
  props: {
    menuItems: Array,
    actionItems: Array,
    rows: Array,
  },
  components: {
    ActionIcons,
    ThreeDotsMenu,
  },
  setup() {},
};
</script>
